// @ts-nocheck
import { phoneNumberFormat } from "../../utils/methods/formatters";
import {
  CREATE_CONTACT_INFO_FAIL,
  CREATE_CONTACT_INFO_REQUEST,
  CREATE_CONTACT_INFO_SUCCESS,
  CREATE_EVENT_INFO_FAIL,
  CREATE_EVENT_INFO_REQUEST,
  CREATE_EVENT_INFO_SUCCESS,
  CREATE_SESSION_STEP1_FAIL,
  CREATE_SESSION_STEP1_REQUEST,
  CREATE_SESSION_STEP1_SUCCESS,
  ADD_SESSION_POSITION_SUCCESS,
  DELETE_SESSION_FAIL,
  DELETE_SESSION_POSITION_FAIL,
  DELETE_SESSION_POSITION_REQUEST,
  DELETE_SESSION_POSITION_SUCCESS,
  DELETE_SESSION_REQUEST,
  DELETE_SESSION_SUCCESS,
  GET_SESSIONS_FOR_SPECIFIC_EVENT_REQUEST,
  GET_SESSIONS_FOR_SPECIFIC_EVENT_SUCCESS,
  ADD_SESSION_POSITION_FAIL,
  ADD_SESSION_POSITION_REQUEST,
  UPDATE_SESSION_STEP1_REQUEST,
  UPDATE_SESSION_STEP1_SUCCESS,
  UPDATE_SESSION_STEP1_FAIL,
  UPDATE_CURRENT_SESSION_STEP1,
  SET_CURRENT_EDITABLE_POSITION,
  UPDATE_CONTACT_INFO_REQUEST,
  UPDATE_CONTACT_INFO_SUCCESS,
  UPDATE_CONTACT_INFO_FAIL,
  UPDATE_EVENT_INFO_REQUEST,
  UPDATE_EVENT_INFO_SUCCESS,
  UPDATE_EVENT_INFO_FAIL,
  CLEAR_SESSION_STEP1_DATA,
  UPDATE_SESSION_STEP1_DATA,
  UPDATE_SESSION_POSITION_REQUEST,
  UPDATE_SESSION_POSITION_SUCCESS,
  UPDATE_SESSION_POSITION_FAIL,
  CLEAR_SESSION_DATA,
  SET_SESSION_DATA,
  SET_SESSION_STEP_2_FORM,
  RESET_CREATE_EVENT_SLICE,
  UPDATE_SUBMITTED_KEY_REQUEST,
  UPDATE_SUBMITTED_KEY_SUCCESS,
  UPDATE_SUBMITTED_KEY_FAIL,
  SET_SESSION_STEP_1_FORM,
  GET_POSITIONS_BY_NAME_REQUEST,
  GET_POSITIONS_BY_NAME_SUCCESS,
  GET_POSITIONS_BY_NAME_FAIL,
  SET_CONTACT_INFO_FORM,
  SET_EVENT_INFO_FORM,
  CLEAR_SESSION_STEP_2_FORM,
  ADD_REQUEST_QUOTE_REQUEST,
  ADD_REQUEST_QUOTE_SUCCESS,
  ADD_REQUEST_QUOTE_FAIL,
  SKIP_SESSION_STEP1_REQUEST,
  SKIP_SESSION_STEP1_SUCCESS,
  SKIP_SESSION_STEP1_FAIL,
  SET_CREATE_EVENT_MULTIPLE_FIELDS,
  EDIT_MULTIPLE_POSITIONS_LOADING,
  EDIT_MULTIPLE_POSITIONS_SUCCESS,
  EDIT_MULTIPLE_POSITIONS_FAIL,
  SET_SESSION_STEP_2_DYNAMIC_POSITIONS,
  GET_SESSIONS_FOR_SPECIFIC_EVENT_FAIL,
  CLEAR_RESET_COUNT,
  SET_LAST_STEP_LOADING,
  ADD_SESSION_TO_POSITION_BOARD,
  REMOVE_SESSION_FROM_POSITION_BOARD,
  EMPTY_POSITION_BOARD,
  CLEAR_SESSION_STEP1_FORM,
  TOGGLE_POSITION_BUTTON_TIMELINE,
  SET_FORM_AS_PARTIAL_EVENT,
} from "../constants/createEvent";

const initialState = {
  loading: false,
  loadingStep4: false,
  currentStep: null,
  sessionStep: null,
  previousStep: null,
  updateSubmittedKeyLoading: false,
  contactInfo: null,
  contactInfoForm: null,
  contactInfoPreviouslySubmittedForm: null,
  isContactInfoSubmitted: false,
  eventInfo: null,
  eventInfoForm: null,
  eventInfoPreviouslySubmittedForm: null,
  isEventInfoSubmitted: false,
  sessionData: {},
  isPartialEvent: false,
  // sessionPositions: [],
  sessionPositionsUI: {
    addSessionPositionLoading: false,
    updateSessionPositionLoading: false,
    deleteSessionPositionLoading: false,
  },
  isSessionSkipped: false,
  skipSessionStep1Loading: false,
  sessionStep1: null,
  isSessionStep1Submitted: false,
  sessionStep1Form: null,
  sessionStep1PreviouslySubmittedForm: null,
  sessionStep2Form: null,
  isSessionStep2Submitted: false,
  sessionsOfEvent: [],
  positions: [],
  editMultiplePositions: {
    editLoading: false,
  },
  reset: {
    count: null,
  },
  // allPositions: [],
  requestQuote: {
    submitFormLoading: false,
  },
  // sessionStep2Form: null,

  // posiiton board
  positionBoard: [],

  // toggle edit button on timeline
  editEventButton: false,
};

const createContactInfoReducer = (state = initialState, action) => {
  let prevStep;
  switch (action.type) {
    // update multiple fields...
    case SET_CREATE_EVENT_MULTIPLE_FIELDS:
      prevStep = state?.currentStep;
      return {
        ...state,
        ...action?.payload,
        previousStep: prevStep,
      };

    //Create contact info
    case CREATE_CONTACT_INFO_REQUEST:
      return {
        ...state,
        loading: true,
        contactInfo: null,
      };
    case CREATE_CONTACT_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        contactInfo: action.payload?.res?.data,
        contactInfoForm: action?.payload?.formData,
        contactInfoPreviouslySubmittedForm: action?.payload?.formData,
        isContactInfoSubmitted: true,
      };
    case CREATE_CONTACT_INFO_FAIL:
      return {
        ...state,
        loading: false,
        contactInfo: null,
      };

    // set contact info form:
    case SET_CONTACT_INFO_FORM:
      return {
        ...state,
        contactInfoForm: action?.payload?.contactInfoForm,
      };

    // Update contact info:
    case UPDATE_CONTACT_INFO_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_CONTACT_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        contactInfo: action.payload?.res?.data,
        contactInfoForm: action?.payload?.formData,
        contactInfoPreviouslySubmittedForm: action?.payload?.formData,
        isContactInfoSubmitted: true,
      };

    case UPDATE_CONTACT_INFO_FAIL:
      return {
        ...state,
        loading: false,
      };

    //Create event info
    case CREATE_EVENT_INFO_REQUEST:
      return {
        ...state,
        loading: true,
        eventInfo: null,
      };
    case CREATE_EVENT_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        eventInfo: action?.payload?.res?.data,
        eventInfoForm: action?.payload?.formData,
        eventInfoPreviouslySubmittedForm: action?.payload?.formData,
        isEventInfoSubmitted: true,
        // eventInfoId: action.payload.data._id,
        // eventStart: action.payload.data.eventStart,
        // eventEnd: action.payload.data.eventEnd
      };
    case CREATE_EVENT_INFO_FAIL:
      return {
        ...state,
        loading: false,
        eventInfo: null,
      };

    // Update event info
    case UPDATE_EVENT_INFO_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_EVENT_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        eventInfo: action?.payload?.res?.data,
        eventInfoForm: action?.payload?.formData || state?.eventInfoForm,
        eventInfoPreviouslySubmittedForm:
          action?.payload?.formData || state?.eventInfoPreviouslySubmittedForm,
        isEventInfoSubmitted: true,
        // eventInfoId: action.payload.data._id,
        // eventStart: action.payload.data.eventStart,
        // eventEnd: action.payload.data.eventEnd
      };
    case UPDATE_EVENT_INFO_FAIL:
      return {
        ...state,
        loading: false,
      };

    // set eventInfoForm
    case SET_EVENT_INFO_FORM:
      return {
        ...state,
        eventInfoForm: action?.payload?.eventInfoForm,
      };

    // set sessionData
    case SET_SESSION_DATA:
      return {
        ...state,
        sessionData: action?.payload?.session || state?.sessionData,
      };

    // clear sessionData
    case CLEAR_SESSION_DATA:
      return {
        ...state,
        sessionData: {},
      };

    //Create session step1
    case CREATE_SESSION_STEP1_REQUEST:
      return {
        ...state,
        loading: true,
        sessionStep1: null,
      };
    case CREATE_SESSION_STEP1_SUCCESS:
      return {
        ...state,
        loading: false,
        isSessionStep1Submitted: true,
        sessionStep1: action.payload?.res?.data,
        sessionData: action?.payload?.res?.data,
        sessionStep1Form: {
          ...action?.payload?.formData,
          sessionPoint:
            action?.payload?.formData?.sessionPoint ||
            action?.payload?.formData?.sessionContactPoint,
        },
        sessionStep1PreviouslySubmittedForm: {
          ...action?.payload?.formData,
          sessionPoint:
            action?.payload?.formData?.sessionPoint ||
            action?.payload?.formData?.sessionContactPoint,
        },
      };
    case CREATE_SESSION_STEP1_FAIL:
      return {
        ...state,
        loading: false,
        sessionStep1: null,
      };
    case CLEAR_SESSION_STEP1_FORM:
      return {
        ...state,
        loading: false,
        isSessionStep1Submitted: false,
        sessionStep1: null,
        sessionData: null,
        sessionStep1Form: null,
        sessionStep1PreviouslySubmittedForm: null,
      };

    // skip session
    case SKIP_SESSION_STEP1_REQUEST:
      return {
        ...state,
        skipSessionStep1Loading: true,
        loading: true,
        sessionStep1: null,
      };
    case SKIP_SESSION_STEP1_SUCCESS: {
      const { location, ...rest } = action?.payload?.res || {};
      return {
        ...state,
        loading: false,
        isSessionSkipped: true,
        skipSessionStep1Loading: false,
        isSessionStep1Submitted: true,
        sessionStep1: action.payload?.res,
        sessionData: action?.payload?.res,
        sessionStep1Form: {
          ...rest,
          sameLocAsEvent: action?.payload?.formData?.sameLocAsEvent,
          contact: phoneNumberFormat(action?.payload?.res?.contact),
        },
        sessionStep1PreviouslySubmittedForm: {
          ...rest,
          sameLocAsEvent: action?.payload?.formData?.sameLocAsEvent,
          contact: phoneNumberFormat(action?.payload?.res?.contact),
        },
      };
    }
    case SKIP_SESSION_STEP1_FAIL:
      return {
        ...state,
        skipSessionStep1Loading: false,
        sessionStep1: null,
        loading: false,
      };

    // set sessionStep2Form
    case SET_SESSION_STEP_2_FORM:
      return {
        ...state,
        sessionStep2Form: action?.payload?.sessionStep2Form,
      };

    case SET_SESSION_STEP_2_DYNAMIC_POSITIONS: {
      return {
        ...state,
        sessionStep2Form: {
          ...state?.sessionStep2Form,
          dynamicPositionsForm: action?.payload?.dynamicPositionsForm,
        },
      };
    }

    // clear sessionStep2Form
    case CLEAR_SESSION_STEP_2_FORM:
      return {
        ...state,
        sessionStep2Form: null,
      };

    // create positions
    case ADD_SESSION_POSITION_REQUEST:
      return {
        ...state,
        sessionPositionsUI: {
          ...state.sessionPositionsUI,
          addSessionPositionLoading: true,
        },
        sessionStep2Form: null,
      };
    case ADD_SESSION_POSITION_SUCCESS:
      return {
        ...state,
        sessionPositionsUI: {
          ...state.sessionPositionsUI,
          addSessionPositionLoading: false,
        },
        sessionStep2Form: action?.payload?.formData,
        isSessionStep2Submitted: true,
      };
    case ADD_SESSION_POSITION_FAIL:
      return {
        ...state,
        sessionPositionsUI: {
          ...state.sessionPositionsUI,
          addSessionPositionLoading: false,
        },
        sessionStep2Form: null,
      };

    // delete session position...
    case UPDATE_SESSION_POSITION_REQUEST:
      return {
        ...state,
        sessionPositionsUI: {
          ...state.sessionPositionsUI,
          updateSessionPositionLoading: true,
        },
      };
    case UPDATE_SESSION_POSITION_SUCCESS:
      return {
        ...state,
        sessionPositionsUI: {
          ...state.sessionPositionsUI,
          updateSessionPositionLoading: false,
        },
      };
    case UPDATE_SESSION_POSITION_FAIL:
      return {
        ...state,
        sessionPositionsUI: {
          ...state.sessionPositionsUI,
          updateSessionPositionLoading: false,
        },
      };

    // delete session position...
    case DELETE_SESSION_POSITION_REQUEST:
      return {
        ...state,
        sessionPositionsUI: {
          ...state?.sessionPositionsUI,
          deleteSessionPositionLoading: true,
        },
      };
    case DELETE_SESSION_POSITION_SUCCESS:
      return {
        ...state,
        sessionPositionsUI: {
          ...state?.sessionPositionsUI,
          deleteSessionPositionLoading: false,
        },
        // sessionPositions: state.sessionPositions?.filter((position) => position._id !== action.payload)
        sessionsOfEvent: state?.sessionsOfEvent?.map((session) => {
          if (session?._id === action?.payload?.sessionId) {
            return {
              ...session,
              position: session?.position
                ?.map?.((currPosition) => {
                  return {
                    ...currPosition,
                    positionData: currPosition?.positionData?.filter?.(
                      (individualPosition) => {
                        return (
                          individualPosition?._id !==
                          action?.payload?.individualPositionId
                        );
                      },
                    ),
                  };
                })
                ?.filter?.((currPosition) => {
                return currPosition?.positionData?.length > 0;
              }),
            };
          } else {
            return session;
          }
        }),
      };
    case DELETE_SESSION_POSITION_FAIL:
      return {
        ...state,
        sessionPositionsUI: {
          ...state?.sessionPositionsUI,
          deleteSessionPositionLoading: false,
        },
      };

    // get all positions
    // case GET_ALL_POSITIONS_REQUEST:
    //   return {
    //     ...state,
    //     loading: true,
    //     allPositions: []
    //   };

    // case GET_ALL_POSITIONS_SUCCESS:
    //   console.log(action?.payload?.data, "positions");
    //   return {
    //     ...state,
    //     loading: false,
    //     allPositions: action.payload?.positions
    //   };

    // case GET_ALL_POSITIONS_FAIL:
    //   return {
    //     ...state,
    //     loading: false,
    //   };

    // get positions by name...
    case GET_POSITIONS_BY_NAME_REQUEST:
      return {
        ...state,
        loading: true,
        positions: [],
      };
    case GET_POSITIONS_BY_NAME_SUCCESS:
      return {
        ...state,
        loading: false,
        positions: action.payload?.positions,
      };
    case GET_POSITIONS_BY_NAME_FAIL:
      return {
        ...state,
        loading: false,
        positions: [],
      };

    //Update session step1
    case UPDATE_SESSION_STEP1_REQUEST:
      return {
        ...state,
        loading: true,
        sessionStep1Id: "",
      };
    case UPDATE_SESSION_STEP1_SUCCESS:
      return {
        ...state,
        loading: false,
        sessionStep1: action.payload?.res,
        sessionStep1Id: action.payload.data._id,
        sessionData: action.payload.data,
        sessionStep1Form: action?.payload?.formData,
        sessionStep1PreviouslySubmittedForm: action?.payload?.formData,
      };
    case UPDATE_SESSION_STEP1_FAIL:
      return {
        ...state,
        loading: false,
        sessionStep1Id: "",
      };

    // update sessionStep1Form
    case SET_SESSION_STEP_1_FORM:
      return {
        ...state,
        sessionStep1Form: action?.payload?.sessionStep1Form,
      };

    // clear session1
    case CLEAR_SESSION_STEP1_DATA:
      return {
        ...state,
        isSessionStep1Submitted: false,
        sessionStep1: null,
        sessionStep1Form: null,
        sessionStep1PreviouslySubmittedForm: null,
      };

    // update session1
    case UPDATE_SESSION_STEP1_DATA:
      return {
        ...state,
        isSessionStep1Submitted: true,
        sessionStep1: action?.payload?.sessionStep1,
        sessionStep1Form: {
          ...action?.payload?.sessionStep1Form,
          contact: phoneNumberFormat(
            action?.payload?.sessionStep1Form?.contact,
          ),
        },
        sessionStep1PreviouslySubmittedForm: action?.payload
          ?.sessionStep1PreviouslySubmittedForm
          ? {
              ...action?.payload?.sessionStep1PreviouslySubmittedForm,
              contact: phoneNumberFormat(
                action?.payload?.sessionStep1Form?.contact,
              ),
            }
          : state?.sessionStep1PreviouslySubmittedForm,
      };

    // // getSessionsPositions
    // case GET_ALL_SESSIONS_POSITIONS_REQUEST:
    //     return {
    //         ...state,
    //         loading: true,
    //         // sessionPositions: []
    //     }
    // case GET_ALL_SESSIONS_POSITIONS_SUCCESS:
    //     console.log(action.payload, 'payload');
    //     return {
    //         ...state,
    //         loading: false,
    //         sessionsOfEvent: state?.sessionsOfEvent?.map(session => {
    //             if (session?._id === action?.payload?.session?._id) {
    //                 return {
    //                     ...session,
    //                     position: action?.payload?.session?.positions
    //                 }
    //             } else {
    //                 return session;
    //             }
    //         })
    //     }
    // case GET_ALL_SESSIONS_POSITIONS_FAIL:
    //     return {
    //         ...state,
    //         loading: false,
    //         // sessionPositions: []
    //     }

    // //delete session position
    // case DELETE_SESSION_POSITION_REQUEST:
    //     return {
    //         ...state,
    //         loading: true
    //     }
    // case DELETE_SESSION_POSITION_SUCCESS:
    //     return {
    //         ...state,
    //         loading: false,
    //         sessionPositions: state.positions?.filter((position) => position._id !== action.payload)
    //     }
    // case DELETE_SESSION_POSITION_FAIL:
    //     return {
    //         ...state
    //     }

    // getSessionsForSpecificevent
    case GET_SESSIONS_FOR_SPECIFIC_EVENT_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_SESSIONS_FOR_SPECIFIC_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        sessionsOfEvent: [...action.payload.data]?.sort(
          (a, b) => Date.parse(a?.createdAt) - Date.parse(b?.createdAt),
        ),
      };

    case GET_SESSIONS_FOR_SPECIFIC_EVENT_FAIL: {
      return {
        ...state,
        loading: false,
      };
    }

    //delete session
    case DELETE_SESSION_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case DELETE_SESSION_SUCCESS:
      return {
        ...state,
        loading: false,
        isSessionStep1Submitted: false,
        sessionStep1: null,
        sessionStep1Form: null,
        sessionsOfEvent: state.sessionsOfEvent?.filter(
          (session) => session._id !== action.payload,
        ),
      };

    case DELETE_SESSION_FAIL:
      return {
        ...state,
        loading: false,
      };

    // Update current session data
    case UPDATE_CURRENT_SESSION_STEP1:
      return {
        ...state,
        sessionStep1Id: action.payload.data._id,
        sessionData: action.payload.data,
      };

    // Set editable position
    case SET_CURRENT_EDITABLE_POSITION:
      return {
        ...state,
        currentEditablePosition: action.payload.data,
      };

    // Update submitted key cases
    case UPDATE_SUBMITTED_KEY_REQUEST:
      return {
        ...state,
        updateSubmittedKeyLoading: true,
      };

    case UPDATE_SUBMITTED_KEY_SUCCESS:
      return {
        ...state,
        updateSubmittedKeyLoading: false,
      };

    case UPDATE_SUBMITTED_KEY_FAIL:
      return {
        ...state,
        updateSubmittedKeyLoading: false,
      };

    // add request quote
    case ADD_REQUEST_QUOTE_REQUEST:
      return {
        ...state,
        requestQuote: {
          ...state?.requestQuote,
          submitFormLoading: true,
        },
      };

    case ADD_REQUEST_QUOTE_SUCCESS:
      return {
        ...state,
        requestQuote: {
          ...state?.requestQuote,
          submitFormLoading: false,
        },
      };

    case ADD_REQUEST_QUOTE_FAIL:
      return {
        ...state,
        requestQuote: {
          ...state?.requestQuote,
          submitFormLoading: false,
        },
      };

    // edit multiple positions start...
    case EDIT_MULTIPLE_POSITIONS_LOADING: {
      return {
        ...state,
        editMultiplePositions: {
          ...state?.editMultiplePositions,
          editLoading: true,
        },
      };
    }

    case EDIT_MULTIPLE_POSITIONS_SUCCESS: {
      return {
        ...state,
        editMultiplePositions: {
          ...state?.editMultiplePositions,
          editLoading: false,
        },
      };
    }

    case EDIT_MULTIPLE_POSITIONS_FAIL: {
      return {
        ...state,
        editMultiplePositions: {
          ...state?.editMultiplePositions,
          editLoading: false,
        },
      };
    }
    // edit multiple positions end...

    //loading step 4
    case SET_LAST_STEP_LOADING:
      return {
        ...state,
        loadingStep4: action?.payload,
      };

    // Reset create event cases
    case RESET_CREATE_EVENT_SLICE:
      return {
        ...initialState,
        // reset: {
        //   ...state?.reset,
        //   count:
        //     typeof state?.reset?.count === "number"
        //       ? (state?.reset?.count + 1) % 10
        //       : 0,
        // },
      };

    // clear reset count
    case CLEAR_RESET_COUNT:
      return {
        ...state,
        reset: {
          ...state?.reset,
          count: null,
        },
      };

    // position board
    case ADD_SESSION_TO_POSITION_BOARD:
      return {
        ...state,
        positionBoard: Array.from(
          new Set([...(state?.positionBoard || []), action?.payload]),
        ),
      };

    case REMOVE_SESSION_FROM_POSITION_BOARD:
      return {
        ...state,
        positionBoard: state?.positionBoard?.filter(
          (sessionId) => sessionId !== action?.payload,
        ),
      };

    // toggle edit button on timeline
    case TOGGLE_POSITION_BUTTON_TIMELINE:
      return {
        ...state,
        editEventButton: action?.payload,
      };

    // set form as partial event
    case SET_FORM_AS_PARTIAL_EVENT:
      return {
        ...state,
        isPartialEvent: true,
      };

    case EMPTY_POSITION_BOARD:
      return {
        ...state,
        positionBoard: [],
      };

    //Default
    default:
      return state;
  }
};

export { createContactInfoReducer, initialState };